import React from 'react'
import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer'
import './styles.scss'
import { getStaticImage } from 'utils/statics'
import { channelName } from 'constants/channels'
import { I18n } from 'react-redux-i18n'

export const registerFonts = () => {
  Font.register({
    family: 'Raleway',
    src: 'https://assets.nixi1.dkv.es/dashboard_front/fonts/Raleway-Bold.ttf'//font
  })
}

const TemplateQr = (props) => {
  const { channels, configPoster } = props
  const { phrase, color, logoUrl } = configPoster
  const debug = false
  const configPDF = (channels) => {
    const QRWrapper = []
    if (channels.length === 1) {
      channels.forEach(it => {
        QRWrapper.push(
          getSpace(1, it)
        )
      })
      return <View style={styles.body1}>{QRWrapper}</View>
    }
    else if (channels.length > 1 && channels.length < 5) {
      channels.forEach(it => {
        QRWrapper.push(
          getSpace(2, it)
        )
      })
      if (channels.length > 2)
        return <View debug={debug} style={styles.body4}>{QRWrapper}</View>
      else
        return <View debug={debug} style={styles.body2}>{QRWrapper}</View>
    }
    else if (channels.length > 4 && channels.length < 7) { //2
      channels.forEach(it => {
        QRWrapper.push(
          getSpace(3, it)
        )
      })
      return <View style={styles.body3}>{QRWrapper}</View>
    }
    else if (channels.length > 6) { //2
      channels.forEach((it, idx) => {
        if ([6, 7].includes(idx)) {
          QRWrapper.push(
            getSpace(7, it)
          )
        }
        else {
          QRWrapper.push(
            getSpace(7, it)
          )
        }
      })
      return <View style={styles.body7}>{QRWrapper}</View>
    }
  }

  const getSpace = (type, channel) => {
    if (type === 1)
      return (
        <View key={`wp-${channel._id || channel.identifier}`} style={{ height: 600, paddingTop: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: -30 }} debug={debug}>
          <View key={channel._id || channel.identifier} style={{ width: 345, height: 345, borderRadius: 30, backgroundColor: '#ffffff', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginHorizontal: 10, }} debug={debug}>
            <View style={{ width: 130, height: 130, borderRadius: 40, position: 'absolute', top: -90, justifyContent: 'center', alignItems: 'center', }} debug={debug}>
              <Image
                src={`${getStaticImage(`/qr/qr-social-wrapper.png`)}`}
                style={{ width: 150, height: 150 }}
              />
              <Image
                src={`${getStaticImage(`/qr/qr-${channel.key === 'wall' ? channel.value.connectionType.substr(0, channel.value.connectionType.length - 4) : channel.key}.png`)}`}
                style={{ width: (channel.key === 'ios' || (channel.key === 'wall' && channel.value?.connectionType === 'ios_api')) ? 65 : 80, position: 'absolute' }}
              />
            </View>
            <Image
              src={channel.qr}
              style={{ width: 265, height: 265 }}
              debug={debug}
            />
            <Text style={{ fontFamily: 'Raleway', fontSize: 14, fontWeight: 'bold', color: '#AFAFAF', position: 'absolute', top: 315 }} debug={debug}>
              {I18n.t(channelName[channel.key || channel.name].name).toUpperCase()}
            </Text>
          </View>
        </View>
      )
    if (type === 2)
      return (
        <View debug={debug} key={channel._id || channel.identifier} style={{ width: 245, height: 245, borderRadius: 30, backgroundColor: '#ffffff', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginHorizontal: 10, }}>
          <View style={{ width: 80, height: 80, borderRadius: 40, position: 'absolute', top: -55, justifyContent: 'center', alignItems: 'center', }}>
            <Image
              src={`${getStaticImage(`/qr/qr-social-wrapper.png`)}`}
              style={{ width: 100, height: 100 }}
            />
            <Image
              src={`${getStaticImage(`/qr/qr-${channel.name === 'wall' ? channel.value.connectionType.substr(0, channel.value.connectionType.length - 4) : channel.key}.png`)}`}
              style={{ width: (channel.key === 'ios' || (channel.key === 'wall' && channel.value?.connectionType === 'ios_api')) ? 35 : 50, position: 'absolute' }}
            />
          </View>
          <Image
            src={channel.qr}
            style={{ width: 185, height: 185 }}
          />
          <Text style={{ fontFamily: 'Raleway', fontSize: 10, fontWeight: 'bold', color: '#AFAFAF', position: 'absolute', top: 220 }}>
            {I18n.t(channelName[channel.key || channel.name].name).toUpperCase()}
          </Text>
        </View>
      )
    if (type === 3)
      return (
        <View key={channel._id || channel.identifier} style={{ marginTop: 60, width: 175, height: 186, borderRadius: 30, backgroundColor: '#ffffff', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginHorizontal: 5, }}>
          <View style={{ width: 50, height: 50, borderRadius: 40, position: 'absolute', top: -35, justifyContent: 'center', alignItems: 'center', }}>
            <Image
              src={`${getStaticImage(`/qr/qr-social-wrapper.png`)}`}
              style={{ width: 70, height: 70 }}
            />
            <Image
              src={`${getStaticImage(`/qr/qr-${channel.key === 'wall' || channel.name === 'wall' ? channel.value.connectionType.substr(0, channel.value.connectionType.length - 4) : channel.key || channel.name}.png`)}`}
              style={{ width: (channel.key === 'ios' || (channel.key === 'wall' && channel.value?.connectionType === 'ios_api')) ? 25 : 35, position: 'absolute' }}
            />
          </View>
          <Image
            src={channel.qr}
            style={{ width: 135, height: 135 }}
          />
          <Text style={{ fontFamily: 'Raleway', fontSize: 10, fontWeight: 'bold', color: '#AFAFAF', marginTop: 15, position: 'absolute', top: 150 }}>
            {I18n.t(channelName[channel.key || channel.name].name).toUpperCase()}
          </Text>
        </View>
      )
    else if (type === 7)
      return (
        <View debug={debug} key={channel._id || channel.identifier} style={{ position: 'relative', marginTop: 50, width: 165, height: 176, borderRadius: 30, backgroundColor: '#ffffff', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginHorizontal: 10 }}>
          <View style={{ width: 50, height: 50, borderRadius: 40, position: 'absolute', top: -35, justifyContent: 'center', alignItems: 'center', }}>
            <Image
              src={`${getStaticImage(`/qr/qr-social-wrapper.png`)}`}
              style={{ width: 70, height: 70 }}
            />
            <Image
              src={`${getStaticImage(`/qr/qr-${channel.key === 'wall' ? channel.value.connectionType.substr(0, channel.value.connectionType.length - 4) : channel.key}.png`)}`}
              style={{ width: (channel.key === 'ios' || (channel.key === 'wall' && channel.value?.connectionType === 'ios_api')) ? 25 : 35, position: 'absolute' }}
            />
          </View>
          <Image
            src={channel.qr}
            style={{ width: 130, height: 130 }}
          />
          <Text style={{ fontFamily: 'Raleway', fontSize: 10, fontWeight: 'bold', color: '#AFAFAF', position: 'absolute', top: 156 }}>
            {I18n.t(channelName[channel.key || channel.name].name).toUpperCase()}
          </Text>
        </View>
      )
    else
      return (null)
  }

  const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: '#ffffff',
      padding: 9,
    },
    section: {
      //flexGrow: 1,
      backgroundColor: color,
      borderRadius: 30,
      width: '100%'
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      justifyItems: 'center',
      marginTop: 20
    },
    text: {
      color: '#FFFFFF',
      fontFamily: 'Raleway',
      fontSize: channels.length < 3 ? 38 : 34,
      fontWeight: 800,
      textAlign: 'center'
    },
    body1: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 45
    },
    body2: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      //marginTop: 45,
      //paddingHorizontal: 18,
      paddingLeft: 22,
      flexWrap: 'wrap',

      height: 600,
      paddingTop: 20,
      position: 'absolute',
      top: -30,
    },
    body4: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignContent: 'space-between',
      //marginTop: 45,
      //paddingHorizontal: 18,
      paddingLeft: 12,
      flexWrap: 'wrap',

      height: 620,
      position: 'absolute',
      paddingTop: 60,
    },
    body3: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      //alignItems: 'center',
      alignContent: 'center',//'space-between',
      //marginTop: 10,
      paddingLeft: 2, //10,
      flexWrap: 'wrap',

      height: 620,
      position: 'absolute',
      //paddingTop: 60,
    },
    body7: {
      display: 'flex',
      flexDirection: 'row',
      //justifyContent: 'space-evenly',
      justifyContent: 'center',
      //alignItems: 'center',
      alignContent: 'flex-start',
      //marginTop: 15,
      //paddingLeft: 10,
      flexWrap: 'wrap',

      paddingLeft: 2, //10,
      height: 620,
      position: 'absolute',
    },
    containerText: {
      width: '70%',
      marginLeft: 12,
    },
  })

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section} debug={debug}>
          <View style={styles.header} debug={debug}>
            {logoUrl && <View debug={debug}>
              <Image
                src={logoUrl}
                style={{ height: 95, marginLeft: 12 }}
              />
            </View>}
            <View style={styles.containerText}>
              <Text style={styles.text}>{I18n.t(phrase)}</Text>
            </View>

            {/* <Image
              src={getStaticImage('/qr/qr-arrow.png')}
              style={channels.length < 5 ? { width: 40, position: 'absolute', top: 35, left: 60 } : { width: 40, position: 'absolute', top: 0, left: 55, transform: 'rotate(40deg)' }}
            /> */}
          </View>
          <View style={{ position: 'relative' }}>
            {channels && channels.length > 0 && configPDF(channels)}
          </View>
          <View style={{ position: 'absolute', bottom: 20, right: 40, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-end' }} debug={debug}>
            <Image
              src={getStaticImage('/qr/qr-poweredby.png')}
              style={{ width: 36, marginLeft: 8 }}
            />
            <Image
              src={getStaticImage('/qr/qr-nixi1-logo-white.png')}
              style={{ height: 16, marginLeft: 12 }}
            />
          </View>
        </View>
      </Page>
    </Document>
  )
}



export default TemplateQr
